import React from "react";
import { LightPurpleCard } from "../../Card/Card";
import track1Image from "./images/track-1.png";
import track2Image from "./images/track-2.png";

type TrackProgressDescriptionProps = {
  isUk?: boolean;
};

export const TrackProgressDescription = ({
  isUk,
}: TrackProgressDescriptionProps) => {
  return (
    <div>
      <div className="mx-auto max-w-[815px] md:pb-[32px] pb-[20px] text-center">
        <h3>Track Your Progress</h3>
        <div>
          At Bnk To The Future, we work with investors focused on building a
          long-term Bitcoin wealth strategy. To support this, we’ve designed two
          tracks to help you grow and manage your Bitcoin wealth.
        </div>
      </div>

      <div className="flex md:flex-row flex-col gap-8">
        <LightPurpleCard className="flex md:flex-row flex-col flex-1 gap-8 pb-16">
          <div className="md:hidden flex justify-between items-center">
            <div className="font-semibold">Track 1</div>

            <img src={track1Image} className="h-[50px]" alt="bf icon" />
          </div>

          <img
            src={track1Image}
            className="h-[50px] hidden md:block"
            alt="bf icon"
          />

          <div>
            <div className="font-semibold hidden md:block">Track 1</div>

            <div>
              {isUk
                ? "The first track guides you through setting up your Bnk To The Future account, making an initial investment, and gaining access to the Bitcoin Wealth Builder Program, valued at $5,000."
                : "The first track guides you through setting up your Bnk To The Future account, making an initial investment, and gaining free access to our Bitcoin Wealth Builder Program, valued at $5,000."}
            </div>
          </div>
        </LightPurpleCard>

        <LightPurpleCard className="flex md:flex-row flex-col flex-1 gap-8 pb-16">
          <div className="md:hidden flex justify-between items-center">
            <div className="font-semibold">Track 2</div>

            <img src={track2Image} className="h-[50px]" alt="bf icon" />
          </div>

          <img
            src={track2Image}
            className="h-[50px] hidden md:block"
            alt="bf icon"
          />

          <div>
            <div className="font-semibold hidden md:block">Track 2</div>

            {isUk ? (
              <div>
                The second track focuses on completing the Bitcoin Wealth
                Builder Program and implementing key tools like Bitcoin Tax
                Technology, Bitcoin Inheritance Technology, and the Portfolio
                Builder Asset Structure to help you build and manage your
                long-term Bitcoin wealth.
              </div>
            ) : (
              <div>
                The second track is focused on completing the Bitcoin Wealth
                Builder Program and implementing essential tools like Bitcoin
                Tax Technology, Bitcoin Inheritance Technology, and the
                Portfolio Builder Asset Protection Structure to build and manage
                your long-term Bitcoin wealth.
              </div>
            )}
          </div>
        </LightPurpleCard>
      </div>

      <div className="mx-auto max-w-[815px] text-sm text-center mt-[32px]">
        Below, you’ll find a tracking tool that will assist you in navigating
        both tracks, which aims to ensure a{isUk ? " " : " smooth and "}logical
        path to success in your Bitcoin wealth-building journey. For full
        details of the Bitcoin Wealth Builder Program,{" "}
        <a
          href={
            isUk
              ? "https://www.bitcoinwealthbuilder.io/bwb"
              : "http://www.simondixon.com/bwb"
          }
          target="_blank"
          className="underline font-semibold"
        >
          click here
        </a>
        .
      </div>
    </div>
  );
};
